// TODO: replace third party dependency and bring keycode enums into our project.
// https://github.com/nfriend/ts-keycode-enum/blob/master/Key.enum.ts
import keycode from 'keycode';
import { warning } from '@origin-digital/helper';
import contains from 'dom-helpers/query/contains';
import ownerDocument from 'dom-helpers/ownerDocument';
var internal = {
  focusKeyPressed: false,
  keyUpEventTimeout: -1
};
export function detectFocusVisible(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  process.env.NODE_ENV !== "production" ? warning(!!instance.focusVisibleCheckTime, 'Style Guide: missing instance.focusVisibleCheckTime') : void 0;
  process.env.NODE_ENV !== "production" ? warning(!!instance.focusVisibleMaxCheckTimes, 'Style Guide: missing instance.focusVisibleMaxCheckTimes') : void 0;
  instance.focusVisibleTimeout = setTimeout(function () {
    var doc = ownerDocument(element);

    if (internal.focusKeyPressed && (doc.activeElement === element || contains(element, doc.activeElement))) {
      callback();
    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
      detectFocusVisible(instance, element, callback, attempt + 1);
    }
  }, instance.focusVisibleCheckTime);
}
var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf(keycode(event)) !== -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.

    clearTimeout(internal.keyUpEventTimeout);
    internal.keyUpEventTimeout = window.setTimeout(function () {
      internal.focusKeyPressed = false;
    }, 1e3);
  }
};

export function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}